// @flow

import type { DiamondType } from '@types/Diamond';

import { shapeProngImagePath } from '@src/utils/images';

const yellowGoldBand = '/images/yellow_goldring.jpg';
const whiteGoldBand = '/images/white_goldring.jpg';
const platinumBand = '/images/platinumring.jpg';

function bandImage (metal) {
  switch (metal) {
    case 'whiteGold':
      return whiteGoldBand;
    case 'yellowGold':
      return yellowGoldBand;
    case 'platinum':
      return platinumBand;
  }
}

function bandStyles (metal, diamond, scale) {
  return {
    width: `${ringWidth(scale)}px`,
    height: `${ringHeight(scale)}px`,
    border: 0
  };
}

function stoneContainerStyles (diamond, scale) {
  return {
    position: 'relative',
    zIndex: 2,
    top: `${rockTop(diamond, scale)}px`,
    left: 0
  };
}

function stoneStyles (diamond, scale) {
  return {
    border: 0,
    width: `${rockWidth(diamond, scale)}px`,
    height: `${rockHeight(diamond, scale)}px`
  };
}

function ringWidth (scale) {
  return 276 * scale;
}

function ringHeight (scale) {
  return 258 * scale;
}

function rockHeight (diamond, scale) {
  return Math.round(diamond.measure_length * 11) * scale;
}

function rockWidth (diamond, scale) {
  return Math.round(
    parseFloat(rockHeight(diamond, scale)) / diamond.length_width_ratio
  );
}

function rockTop (diamond, scale) {
  const heightBuffer = scale === 1 ? 11 : -1;
  // return a negative number
  return (
    Math.round(
      ringHeight(scale) / 2 - heightBuffer + rockHeight(diamond, scale) / 2
    ) * -1
  );
}

function rockLeft (diamond: DiamondType, scale: number): number {
  return Math.round(ringWidth(scale) / 2 - rockWidth(diamond, scale) / 2);
}

type PropsType = {
  metal: string,
  diamond: DiamondType,
  scale: number
};

const DiamondInBand = ({ metal, diamond, scale }: PropsType) => {
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}>
      <div style={{ zIndex: 1 }}>
        <img src={bandImage(metal)} style={bandStyles(metal, diamond, scale)} />
      </div>
      <div style={stoneContainerStyles(diamond, scale)}>
        <img
          src={shapeProngImagePath(diamond)}
          style={stoneStyles(diamond, scale)}
        />
      </div>
    </div>
  );
};

DiamondInBand.defaultProps = {
  scale: 1
};

export default DiamondInBand;
